import React from 'react';
import Icon from 'components/AppIcon';

const FilterPanel = ({ filters, setFilters, onClose }) => {
  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const clearFilters = () => {
    setFilters({
      subscriptionType: 'all',
      dateRange: 'all',
      renewalHistory: 'all'
    });
  };

  return (
    <div className="mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
      <div className="flex items-center justify-between mb-4">
        <h4 className="text-sm font-medium text-gray-900">Advanced Filters</h4>
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-gray-500"
        >
          <Icon name="X" size={16} />
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">
            Subscription Type
          </label>
          <select
            value={filters.subscriptionType}
            onChange={(e) => handleFilterChange('subscriptionType', e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-green-500 focus:border-green-500"
          >
            <option value="all">All Types</option>
            <option value="basic">Basic</option>
            <option value="premium">Premium</option>
            <option value="vip">VIP</option>
            <option value="monthly">Monthly Plans</option>
            <option value="yearly">Yearly Plans</option>
          </select>
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">
            Date Range
          </label>
          <select
            value={filters.dateRange}
            onChange={(e) => handleFilterChange('dateRange', e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-green-500 focus:border-green-500"
          >
            <option value="all">All Dates</option>
            <option value="today">Today</option>
            <option value="week">This Week</option>
            <option value="month">This Month</option>
            <option value="custom">Custom Range</option>
          </select>
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">
            Renewal History
          </label>
          <select
            value={filters.renewalHistory}
            onChange={(e) => handleFilterChange('renewalHistory', e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-green-500 focus:border-green-500"
          >
            <option value="all">All Clients</option>
            <option value="first-time">First Time</option>
            <option value="renewed-once">Renewed Once</option>
            <option value="multiple-renewals">Multiple Renewals</option>
            <option value="never-renewed">Never Renewed</option>
          </select>
        </div>
      </div>

      <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-200">
        <button
          onClick={clearFilters}
          className="text-sm text-gray-600 hover:text-gray-800"
        >
          Clear all filters
        </button>
        <div className="flex items-center space-x-2">
          <span className="text-xs text-gray-500">
            {Object.values(filters).filter(v => v !== 'all').length} active filters
          </span>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;